import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { RentalDispenseItem } from "@/models/rental-dispense-item.model"
import type { IRentalDispenseItem } from "@/interfaces/api/rental-dispense-item.interface"
import { RentalDispenseItemRepository } from "@/repositories/rental-dispense-item-repository"
import { useRentalDispenseItemStore } from "@/store/rental-dispense-item.store"
import { storeToRefs } from "pinia"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"

export class RentalDispenseItemController extends GenericModelController<
  RentalDispenseItem,
  IRentalDispenseItem,
  RentalDispenseItemRepository
> {
  constructor() {
    const rentalDispenseItemStore = useRentalDispenseItemStore()
    const { rentalDispenseItems } = storeToRefs(rentalDispenseItemStore)

    const storeFunctionsConfig = {
      collection: rentalDispenseItems
    }

    super(RentalDispenseItem, storeFunctionsConfig, new RentalDispenseItemRepository())

    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      RentalDispenseItem,
      rentalDispenseItems
    )
  }
}
